import Button from '@liquidweb-dev/undercurrent/Button';
import Menu from '@liquidweb-dev/undercurrent/Menu';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import { useState } from 'react';
import CartButton from '../common/CartButton';
import CreateMenuContent from '../common/CreateMenuContent';

export function SmallNavCreateFooter({ sx, ...rest }) {
	const [open, setOpen] = useState(false);

	return (
		<Stack
			{...rest}
			direction="row"
			sx={combineSx(
				{
					height: 64,
					padding: 150,
					gap: 200,
				},
				sx,
			)}
		>
			<Button
				color="highlight"
				variant="secondary"
				fullWidth
				onClick={() => setOpen(true)}
				size="large"
			>
				Create and deploy
			</Button>
			<CartButton />
			<Menu
				useSwipeableDrawer
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				anchor="bottom"
			>
				<CreateMenuContent
					onClose={() => {
						setOpen(false);
					}}
				/>
			</Menu>
		</Stack>
	);
}

export default SmallNavCreateFooter;
